<template>
  <div :class="isReport ? 'is-report' : 'not-report'" class="battery_wrap_menu">
    <ui-tooltip v-show="description && isReport && showDescription" arrowTop arrowRight class="battery__description">
      <span v-html="description"></span>
    </ui-tooltip>

    <div v-show="!(description && isReport)" class="battery__description__type2">
      <p v-html="description"></p>
    </div>

    <div class="battery svg clearfix"
         :class="{'large': isLargeSize}"
         v-if="!allSpend"
         @mouseenter="showDescription = true"
         @mouseleave="showDescription = false">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
        <g fill="none" fill-rule="evenodd" stroke="#666" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
          <rect width="22" height="12" x="3" y="9" rx="2"/>
          <path d="M28 16v-2"/>
        </g>
        <g :fill="batteryColor">
          <rect :width="batteryFillingWidth" height="8" x="5" y="11"></rect>
        </g>
      </svg>
    </div>

    <div class="battery icon icon--battery clearfix empty"
         v-else
         @mouseenter="showDescription = true"
         @mouseleave="showDescription = false">
    </div>
  </div>
</template>

<script>
import UiTooltip from '@/components/ui/UiTooltip'
import { mapGetters } from 'vuex'

export default {
  name: 'BatteryIndicator',
  components: {
    UiTooltip
  },
  data () {
    return {
      showDescription: false
    }
  },
  props: {
    isReport: {
      type: Boolean,
      required: false
    },
    isLargeSize: {
      type: Boolean,
      required: false
    },
    description: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'creditData'
    ]),
    allSpend () {
      return this.creditData.hasPlan && !this.creditData.remain
    },
    batteryColor () {
      const value = this.creditData.percentage

      if (value < 30) {
        return '#e92020'
      } else if (value < 70) {
        return '#ffa200'
      } else {
        return '#70c9d8'
      }

      // eslint-disable-next-line no-unreachable
      throw new Error(`invalid battery percentage: ${this.creditData.percentage}`)
    },
    batteryFillingWidth () {
      return this.creditData.percentage / 200 * 30 + 3
    }
  }
}
</script>

<style lang="scss">
.battery_wrap_menu {
  position: relative;
  display: inline-block;

  &.not-report {
    .battery {
      pointer-events: none;
    }
  }

  .battery {
    position: relative;
    cursor: pointer;
    vertical-align: middle;

    &:hover:after {
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      background-color: #000;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0.06;
      border-radius: 50%;
    }

    .battery-filling {
      display: inline-block;
      position: absolute;
      top: 11px;
      left: 5px;
      height: 8px;
    }

    &.svg {
      width: 30px;
      height: 30px;
      display: inline-block;

      &.large {
        width: 60px;
        height: 60px;
      }

      svg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 2px;
      }
    }
  }

  .battery__description {
    position: absolute;
    z-index: 1;
    top: 42px;
    right: -5px;
  }

  .battery__description__type2 {
    display: inline-block;
    white-space: nowrap;
    vertical-align: middle;
    margin-right: 15px;

    strong {
      color: $brandColor;
      font-weight: bold;
    }
  }
 }
</style>
